var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253,
    height: 180,
    viewBox: "0 0 253 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 64,
    fill: "#EFF7FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 32.5,
    r: 21.5,
    fill: "#F77676"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M36 33.28l5.565 4.276L52 26"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#4C85FF",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 14,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 32
  }, "\u041F\u0410\u0420\u0422\u041D\u0415\u0420\u042B"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 64,
    fill: "#EFF7FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 31.5,
    r: 21.5,
    fill: "#81D39D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 6,
    x: 78,
    y: 29,
    fill: "#81D39D",
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.734 162c3.287-10.155 4.931-16.253 4.931-18.293 0-3.06 1.227-5.52 2.469-7.46 1.242-1.939 1.242-6.518-.614-8.347-1.855-1.83-4.147-.615-5.02 1.372-.873 1.986-2.21 6.08-2.21 10.31s-1.99 7.174-1.99 9.156c0 1.32-.767 5.742-2.3 13.262h4.734zM206 162c4.641-8.47 7.06-14.082 7.257-16.835.295-4.13 3.31-5.747 3.31-7.95 0-2.204 2.092-4.344 4.165-4.209 2.073.135 2.702 1.82 1.98 3.741-.466 1.241-.937 5.24-1.98 8.283-.571 1.666-2.073 3.408-2.073 3.408s-1.195 1.004-2.092 2.671c-.795 1.477-2.53 5.107-5.205 10.891H206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 161.994c.746-5.584 1.986-9.003 3.72-10.256 2.6-1.879 3.42-3.866 5.264-3.732 1.843.135 2.402 1.817 1.76 3.732-.414 1.238-1.294 2.557-2.221 5.591-.508 1.662-3.023 4.671-3.023 4.671l-5.5-.006zM196 161.994c-.678-5.584-1.805-9.003-3.381-10.256-2.365-1.879-3.11-3.866-4.786-3.732-1.676.135-2.184 1.817-1.6 3.732.376 1.238 1.176 2.557 2.019 5.591C188.713 158.991 191 162 191 162l5-.006zM202.491 162c-.804-6.697-1.207-10.88-1.207-12.549 0-2.503 3.716-30.025 3.716-34.208s-.842-8.132-2.691-9.63c-1.85-1.496-5.647-.854-5.069 8.831.263 4.411-2.24 29.167-2.24 31.42 0 2.357.578 4.258.578 5.446 0 1.55.355 5.113 1.063 10.69h5.85z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.635e30c8ec3b5eea29cf384898aeca02.svg";
export { ForwardRef as ReactComponent };